import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { getUser, userIsLoading, getLoggedInUserOrganization } from "../store/iam/selectors";
import { getLoggedInUser, fetchOrganization } from "../store/iam/operations";
import AuthTopNav from "../components/layout/AuthTopNav/AuthTopNav";
import { getPageTitle } from "../components/layout/SideMenu/menuItems";
import { fetchSubscription, fetchSubscriptionPlans } from "../store/sales/operations";
import { getSubscription } from "../store/sales/selectors";
import { logout as _logout } from "../iam/logout";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "../useAppDispatch";

const AuthHeader = ({ showPageHeader }) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const currentPathName = location.pathname;

    const user = useSelector(getUser);
    const organization = useSelector(getLoggedInUserOrganization);
    const isLoadingUser = useSelector(userIsLoading);
    const subscription = useSelector(getSubscription);
    const pageTitle = getPageTitle(currentPathName);
    const orgRole = organization ? organization["role"] : null;

    useEffect(() => {
        dispatch(fetchSubscriptionPlans());
        if (!user) {
            dispatch(getLoggedInUser());
            dispatch(fetchSubscription());
        }
        dispatch(fetchOrganization());
        // eslint-disable-next-line
    }, []);

    return (
        <AuthTopNav
            isLoading={isLoadingUser}
            _logout={() => dispatch(_logout())}
            user={user}
            push={navigate}
            pageTitle={pageTitle}
            selectedMenuItem={currentPathName}
            showPageHeader={showPageHeader}
            subscription={subscription}
            orgRole={orgRole}
        />
    );
};

export default AuthHeader;
